export default __webpack_public_path__ + "static/media/portrait.254b1244.svg";